
import { destroy, get, getOne, post, put } from "../apis/httpClient"

export const pagingFactory=(params)=>get('/api/v1/factory/paging',params)
export const detailFactory=(query)=>getOne(`/api/v1/factory/detail/${query}`)
export const updateFactory=(body)=>put(`/api/v1/factory/update`,body)
export const createFactory=(body)=>post(`/api/v1/factory/create`,body)
export const deleteFactory=(body)=>destroy(`/api/v1/factory/delete`,body)
